export const state = {
  settings: null,
  community: null,
  register_info: null,
};
